import React, { useMemo } from "react";
import { graphql } from "gatsby";
import Slider from "react-slick";
import slugify from "@sindresorhus/slugify";
import { Link } from "./link";
import sortPosition from "../utility/sort-position";
import classnames from "classnames";

const FeatureContent = ({ item }) => {
  return (
    <>
      {item.icon && (
        <img
          src={item.icon.node.publicURL}
          alt={item.title}
          width="50"
          height="50"
          className="banner-features__icon d-inline-block"
          loading="lazy"
        />
      )}
      <div className="banner-features__feature">{item.title}</div>
      {item?.abstract && <div dangerouslySetInnerHTML={{ __html: item.abstract }}></div>}
    </>
  );
};

const ModuleBannerFeatures = ({ module, className, isFirst }) => {
  const settings = {
    dots: true,
    infinite: false,
    autoplay: false,
    arrows: false,
    swipe: true,
    slidesToShow:
      module.titleFieldSet.filter((item) => item.title).length < 3
        ? module.titleFieldSet.filter((item) => item.title).length
        : 3,
    responsive: [
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <>
      {module?.anchorDesktop && (
        <span id={slugify(module.anchorDesktop)} className="tabs__scroll-anchor" />
      )}
      <section className={`section banner-features${className ? ` ${className}` : ""}`}>
        <div className="container-fluid">
          {module.moduleTitle && (
            <div className="row mb-3">
              <div className="col-12">
                {isFirst ? (
                  <h1 className="section__title">{module.moduleTitle}</h1>
                ) : (
                  <h2 className="section__title">{module.moduleTitle}</h2>
                )}
              </div>
            </div>
          )}
          <div className="row">
            <div className="col-lg-10 offset-lg-1">
              <Slider {...settings} className="slider-banner-features">
                {module.titleFieldSet
                  .filter((item) => item.title)
                  .map((item, i) => (
                    <React.Fragment key={i}>
                      {item?.link ? (
                        <Link
                          to={item.link}
                          className={classnames(
                            "banner-features__slide text-center",
                            `banner-features__slide--${
                              module.titleFieldSet.filter((item) => item.title).length
                            }`
                          )}
                        >
                          <FeatureContent item={item} />
                        </Link>
                      ) : (
                        <div className="banner-features__slide text-center">
                          <FeatureContent item={item} />
                        </div>
                      )}
                    </React.Fragment>
                  ))}
              </Slider>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

const BannerFeatures = ({ data, className, isFirst }) => {
  // Filtro i moduli perchè ci sia almeno un elemento col titolo
  const modules = useMemo(
    () =>
      data.moduleTitleFieldSet.length
        ? data.moduleTitleFieldSet
            .filter((module) => module.titleFieldSet.filter((item) => item.title).length)
            .sort(sortPosition)
        : data.moduleTitleFieldSet,
    [data.moduleTitleFieldSet]
  );
  return (
    <>
      {modules.map((module, i) => (
        <ModuleBannerFeatures module={module} className={className} key={i} isFirst={isFirst} />
      ))}
    </>
  );
};

export default BannerFeatures;
export const fragment = graphql`
  fragment PurchaseMotivationFragment on LiferayPurchaseMotivation {
    id
    liferayFields {
      siteId
      articleId
    }
    moduleTitleFieldSet {
      moduleTitle
      anchorDesktop
      anchorMobile
      position
      titleFieldSet {
        title
        icon {
          node {
            publicURL
          }
        }
        abstract
        link
      }
    }
  }
`;
